import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

import { Question } from "../../shared/models/question";
import { QuestionSetLabel } from "../../shared/models/question-set-label";

@Component({
  selector: 'dac-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.css']
})
export class QuestionComponent implements OnInit {

  @Input() question:Question;
  @Input() labels:QuestionSetLabel[];
  @Input() vertical:boolean;
  @Output() answered:EventEmitter<Question>;

  private LABEL_SIZE:number = 6;
  private question_class_size:number = 6;

  constructor() { 
    this.answered = new EventEmitter<Question>();
  }

  ngOnInit() {
    this.calculateColumnSizes();
  }

  get horizontal() {
    return !this.vertical;
  }

  getLabelClasses() {
		if (this.labels.length < this.LABEL_SIZE) {
      let colSize = this.LABEL_SIZE - this.labels.length;
      return "col-lg-" + colSize;
		}
		
		return "d-none";
  }
  
  public notifyAnswered() {
    this.answered.emit(this.question);
  }

  public getQuestionTextClasses() {
        //ng-class="{'col-md-6': horizontal, 'col-xs-12': vertical}" 
        if (this.horizontal) {
            return 'col-lg-' + this.question_class_size;
        }
        else {
            return 'col-12';
        }
    }
    
    calculateColumnSizes() {
		if (this.labels && this.labels.length > 6) {
			// keep a minimum of 2 rows for the question.
			this.question_class_size = Math.max(2, 12 - this.labels.length);
		}
		else {
			this.question_class_size = this.LABEL_SIZE;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/assessments/question/question.component.ts